type BadgeVariant = "success" | "warning" | "info" | "destructive" | "secondary" | "purple";

const STATUS_MAP: Record<string, BadgeVariant> = {
  // Freigabe-Status
  approved: "success",
  pending: "warning",
  open: "secondary",

  // Beschäftigungsstatus
  active: "success",
  inactive: "secondary",

  // Kalender
  vacation: "info",
  sick: "destructive",
  holiday: "warning",
  work: "success",

  // MFA-Status
  mfa_active: "success",
  mfa_grace_period: "warning",
  mfa_overdue: "destructive",
  mfa_enforced: "info",
  mfa_disabled: "secondary",
};

export function getStatusBadgeVariant(status: string): BadgeVariant {
  return STATUS_MAP[status.toLowerCase()] ?? "secondary";
}
